"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-connect-icon.svg.js",
    _path,
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear_5538_35920)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5538_35920)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, React.createElement("path", {
    d: "M14.328 20.072a8.468 8.468 0 01-1.575-9.774 7.296 7.296 0 00-7.204 11.154l-.833 3.04 3.044-.836a7.296 7.296 0 009.654-1.612 8.42 8.42 0 01-3.086-1.972z",
    fill: "#878787",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18
    },
    __self: this
  }), React.createElement("path", {
    d: "M25.464 8.936a7.296 7.296 0 10-1.223 11.305l3.044.831-.837-3.044a7.297 7.297 0 00-.984-9.092zm-2.448 2.675l1.597 2.373h-2.816l-1.17-2.373h2.389zm-7.464 1.752l1.093-1.752h2.914l-1.075 1.725-2.932.027zm4.308 2.794l-.077-.177-1.09-2.516 1.086-1.753 1.213 2.372-1.132 2.074zm3.18.426h-2.427l1.185-2.358h2.817l-1.575 2.358z",
    fill: "#E87824",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_5538_35920",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37
    },
    __self: this
  })), React.createElement("clipPath", {
    id: "prefix__clip0_5538_35920",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.4 6.8)",
    d: "M0 0h23.2v18.008H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;